import { Divider, Flex } from "@mantine/core";

export function WorkspaceHeaderDivider() {
  return (
    <Flex px="xs">
      <Divider color="border.1" orientation="vertical" h={45} my="auto" />
    </Flex>
  );
}
